export const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
export const MONTHS_FULL = ["January","February","March","April","May","June","July","August","September","October","November","December"];
export const WEEKDAYS = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];

export const LEGEND = [
  { color:"#5b9bd5", label:"TMS1" },
  { color:"#70ad47", label:"MY28 FPP – EUVII" },
  { color:"#ffc000", label:"Schwerlast" },
  { color:"#d9d9d9", label:"H2-ICE" },  
  { color:"#c00000", label:"Individual ext." },
  { color:"#c00000", label:"39E" },
  { color:"#bfbfbf", label:"MY28 TG-V" },
  { color:"#9dc3e6", label:"MY 2026" },
  { color:"#a9d18e", label:"TruE" },
  { color:"#f4b942", label:"Tankportfolio" },
  { color:"#c9c9c9", label:"Modi/Individ._alt" },
  { color:"#548235", label:"MY28 FPP – RoW" },
];

export const CHIP_STYLES = {
  cg: { bg:"#d4edda", color:"#1a5c2a", dot:"#28a745" },
  cr: { bg:"#f8d7da", color:"#721c24", dot:"#dc3545" },
  cb: { bg:"#cce5ff", color:"#004085", dot:"#007bff" },
  cm: { bg:"#f3d0ec", color:"#6b0e57", dot:"#d63097" },
};

export const CHECKLIST_ITEMS = [
  "Mock-Up",
  "Vehicle Configuration",
  "Regulations",
  "P-Release",
  "Order Cleanup",
  "KAST Check",
  "Virtual Model",
  "Buildability Validation",
  "Line-Off Blocking Parts",
  "EOL Criteria",
];

export const STATUS_CYCLE = ["green", "yellow", "red"];

export const EMPTY_FORM = {
  vehicleExists: "",
  projektname: "",
  projektnummer: "",
  fahrzeugnummer: "",
  fahrzeugverantwortlicher: "",
  ba_soll: "",
  aktuelle_station: "",     // maps to Athena aktuelle_station (Assembly Line)
  bau_inkl__ibn: false,
  haertegrad: "HG0",
};
